import React from "react";
import "./UserDashboard.css";
import { useNavigate } from "react-router-dom";
import "chartjs-adapter-date-fns";
import UserCharts from "../UserCharts/UserCharts";
import UserQuizSummary from "./UserQuizSummary/UserQuizSummary";
import UserRecommendations from "./UserRecommendations/UserRecommendations";
import UserPersonalitySummary from "./UserQuizSummary/UserPersonalityQuizSummary";
import UserPersonalityVisualisation from "../UserCharts/UserPersonalityVisualisation";
function UserDashboard({ userData }) {
  const navigate = useNavigate();

  // handling the logout button
  const handleLogout = () => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.message);
        navigate(`/`);
      })
      .catch((error) => console.error("Error logging out:", error));
  };

  if (!userData) {
    return <div>Loading...</div>; // or null
  }

  return (
    <div className="dashboard">
      <header className="dash-header">
        <button
          onClick={() => {
            if (userData.scores.length === 0) {
              navigate(`/consent`, { state: { from: "dashboard" } });
            } else {
              navigate(`/quiz-nav`);
            }
          }}
        >
          Quiz
        </button>
        <button onClick={handleLogout}>Log Out</button>
      </header>

      <div className="profile">
        <h3>{userData.username}</h3>
        <p>{userData.email}</p>

        <UserQuizSummary scores={userData.scores} />
      </div>

      <div className="main-content">
        {userData.scores.length > 0 && <UserCharts scores={userData.scores} />}

        <UserRecommendations />
      </div>

      <h3>Personality Dashboard</h3>

      <div className="main-content">
        {/* Personality charts for logged-in user */}
        <UserPersonalityVisualisation userData={userData} />

        {/* Personality summary */}
        {userData.scores.length > 0 && <UserPersonalitySummary />}
      </div>
    </div>
  );
}

export default UserDashboard;
